import { Row } from "antd"
import { DateFormat, Text } from "components/common"
import { t } from "i18next"

const UpdatedAt = ({ data }) => {
  return (
    <>
      <DateFormat date={data?.updatedAt} dateClassName="" />
      <Row className="gray-800">
        <Text>{t("Requested on:")}</Text>
        <DateFormat date={data?.requestedAt} icon="" />
      </Row>
    </>
  )
}

export default UpdatedAt
